var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{staticClass:"mx-3",attrs:{"label":'Advanced Form'},on:{"change":function($event){_vm.switchFormType()}},model:{value:(_vm.buttonStatus),callback:function ($$v) {_vm.buttonStatus=$$v},expression:"buttonStatus"}})}
var staticRenderFns = []

export { render, staticRenderFns }